import RadioGroupPrimitive, { RadioGroupProps } from '@eversports/klimt-primitives/legacy/RadioGroup'
import { Controller, ControllerProps, useFormContext } from 'react-hook-form'

type Props = RadioGroupProps & Omit<ControllerProps, 'render'>

const RadioGroup = ({ children, rules, name, shouldUnregister, defaultValue, ...rest }: Props) => {
  const { control } = useFormContext()
  return (
    <Controller
      control={control}
      rules={rules}
      name={name}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <RadioGroupPrimitive {...rest} value={value} onChange={onChange}>
          {children}
        </RadioGroupPrimitive>
      )}
    />
  )
}

export default RadioGroup
